export enum FeatureFlags {
  RobinhoodServiceEnabled = 'robinhood-service-enabled',
  FlowIdByAction = 'tools-flow-id-by-action',
  ShouldDisplayMultihitFeature = 'should-display-multihit-feature',
  ShouldWriteMultihitFeature = 'should-write-multihit-feature',
  ShouldEnableRfiForOrg = 'tools-should-enable-rfi-for-org',
  SherlockAllowOtherEddComplianceRejectionLabel = 'sherlock-allow-other-edd-compliance-rejection-label',
  ShouldDisplayNewMmFeatures = 'tools-should-display-new-mm-features',
  ShouldHidePphTabs = 'tools-should-hide-pph-tabs',
  ShouldDisplayAgentSuggestions = 'risk-should-display-agent-suggestions',
  EnableMultihitV1 = 'tools-enable-multihit-v1',
  ToolsRfiConfirmedPartnerConfig = 'tools-rfi-confirmed-partner-config',
  ShouldCreateLimitationTasks = 'tools-should-create-limitation-tasks',
  ShouldCreateFraudReferralTasks = 'tools-should-create-fraud-referral-tasks',
  ShouldPreventCreateEddTaskOnCrrCalculated = 'tools-should-prevent-create-edd-task-on-crr-calculated',
  ToolsShouldDisplayCashAdvancedAgentResponse = 'tools-should-display-cash-advanced-agent-response',
  ToolsShouldDisplaySfAgentResponse = 'tools-should-display-sf-agent-response',
  ToolsShouldDisplayKybNullAgentResponse = 'tools-should-display-kyb-null-agent-response',
  ToolsShouldDisplayDMCreatorEmail = 'tools-should-display-dm-creator-email',
  ShouldDisplayUserEventTab = 'tools-should-display-user-event-tab',
  MosEgressEmailXeroDomain = 'mos-egress-email-xero-domain',
  ShouldHideCsomSystemDecisions = 'tools-should-hide-csom-system-decisions',
  ToolsShouldUseTruliooKycVendor = 'tools-should-use-trulioo-kyc-vendor',
  ToolsEnableDataLoaderCache = 'tools-enable-data-loader-cache',
  ToolsShouldHideCddLabel = 'tools-should-hide-cdd-label',
  ShouldShowRiskNotificationViewDetails = 'tools-should-show-risk-notification-view-details',
  ShouldShowRichTextComments = 'tools-should-show-rich-text-comments',
  MosIdentityXeroClientId = 'mos-identity-xero-client-id',
  ShouldUseRailsEvaluation = 'tools-should-use-rails-evaluation',
  ShouldResolvePartnerName = 'tools-should-resolve-partner-name',
  PayrollByCardPilotOrg = 'tools-payroll-by-card-pilot-org',
  ShouldDisplayVendorSummaryAiPanel = 'tools-should-display-vendor-summary-ai-panel',
  ToolsShouldDisplayProhibitedIndustriesV2AgentResponse = 'tools-should-display-prohibited-industries-v2-agent-response',
  ToolsShouldSupportAtoHandlingAutomation = 'tools-should-support-ato-handling-automation',
  ShouldHideProhibitedClearingTags = 'tools-should-hide-prohibited-clearing-tags',
  ToolsShouldDisplayCustomerSegment = 'tools-should-display-customer-segment'
}
